<template>
    <img v-if="!backgroundImage" v-bind:class="className" :data-src="image.replace('storage/','storage/thumbnails-desktop/')" :data-srcset="image.replace('storage/','storage/thumbnails-desktop/')+' 2x,'+image.replace('storage/','storage/thumbnails-mobile/')" :style="style" class="lazyImage">
</template>

<script>
import lozad from 'lozad'

export default {
  name: 'ImageLazy',
  props: {
    backgroundImage: {
      type: Boolean,
      default: false
    },
    backgroundColor: {
      type: String,
      default: '#efefef'
    },
    height: {
      type: Number,
      default: null
    },
    className: {
      type: String,
      default: null
    },
    image: {
      type: String,
      default: 'https://nkcreative.hu/assets/loading.svg'
    },
    imageSrcset: {
      type: String,
      default: null
    },
    width: {
      type: Number,
      default: null
    }
  },
  watch: {
    image: {
      handler: function (val, oldVal) {
        if (val !== oldVal) {
          setTimeout(function () {
            this.$el.setAttribute('data-src', val)
            if (this.$el.getAttribute('data-loaded') === 'true') {
              this.$el.setAttribute('src', val)
            }
          }, 1000)
        }
      }
    }
  },
  data () {
    return {
      loading: true
    }
  },
  computed: {
    aspectRatio () {
      // Calculate the aspect ratio of the image
      // if the width and the height are given.
      if (!this.width || !this.height) return null
      return (this.height / this.width) * 100
    },
    style () {
      // The background color is used as a
      // placeholder while loading the image.
      // You can use the dominant color of the
      // image to improve perceived performance.
      // See: https://manu.ninja/dominant-colors-for-lazy-loading-images/
      const style = { backgroundColor: this.backgroundColor }

      if (this.width) style.width = `${this.width}px`
      if (this.height) style.height = `${this.height}px`
      // If the image is still loading and an
      // aspect ratio could be calculated, we
      // apply the calculated aspect ratio by
      // using padding top.
      const applyAspectRatio = this.loading && this.aspectRatio
      if (applyAspectRatio) {
        // Prevent flash of unstyled image
        // after the image is loaded.
        style.height = 0
        // Scale the image container according
        // to the aspect ratio.
        style.paddingTop = `${this.aspectRatio}%`
      }
      return style
    }
  },
  mounted () {
    // As soon as the <img> element triggers
    // the `load` event, the loading state is
    // set to `false`, which removes the apsect
    // ratio we've applied earlier.
    this.load()
  },
  methods: {
    load () {
      const setLoadingState = () => {
        this.loading = false
      }
      this.$el.addEventListener('load', setLoadingState)
      // We remove the event listener as soon as
      // the component is destroyed to prevent
      // potential memory leaks.
      this.$once('hook:destroyed', () => {
        this.$el.removeEventListener('load', setLoadingState)
      })

      // We initialize Lozad.js on the root
      // element of our component.
      const observer = lozad(this.$el)
      observer.observe()
    }
  }
}
</script>

<style >

    .lazyImage {
        max-width: 100%;
        max-height: 100%;
        width: auto;
        height: auto;
        vertical-align: middle;
    }
</style>



// WEBPACK FOOTER //
// src/components/ImageLazy.vue